export const incidentClosed = item => Number(item.flowStep) === 7 || ['CLOSED', 'FALSE_CLOSED'].includes(item.status)

// 有真实坐标时使用真实坐标；非空间事件只定位到实际规划网格，不伪造现场地址。
export function locateMapIncidents (template, incidents, grids) {
  const finite = value => value !== '' && value != null && Number.isFinite(Number(value))
  const cells = Object.fromEntries((template.cells || []).map(cell => [cell.id, cell]))
  return incidents.map((item, index) => {
    // 采集事件的冻结坐标由服务端按网格生成，仍须注明是网格定位。
    if (finite(item.x) && finite(item.y)) return { ...item, mapLocated: true, mapLocationSource: item.source === 'NON_SPATIAL_EVENT' ? 'GRID' : 'EXACT', mapNumber: index + 1 }
    const grid = (grids || []).find(g => g.code === (item.grid || item.gridId))
    const members = (grid?.cellIds || grid?.cells || []).map(id => cells[id]).filter(Boolean)
    const centers = members.map(cell => {
      const g = cell.geometry || {}, ring = g.coordinates?.[0]
      if (String(g.type).toUpperCase() === 'POLYGON' && ring?.length >= 3) return [ring.reduce((s, p) => s + Number(p[0]), 0) / ring.length, ring.reduce((s, p) => s + Number(p[1]), 0) / ring.length]
      const w = Number(g.width ?? template.width / template.cols), h = Number(g.height ?? template.height / template.rows)
      return [Number(g.x ?? cell.col * w) + w / 2, Number(g.y ?? cell.row * h) + h / 2]
    }).filter(p => p.every(Number.isFinite))
    return centers.length ? { ...item, x: centers.reduce((s, p) => s + p[0], 0) / centers.length, y: centers.reduce((s, p) => s + p[1], 0) / centers.length, mapLocated: true, mapLocationSource: 'GRID', mapNumber: index + 1 }
      : { ...item, mapLocated: false, mapLocationSource: 'UNLOCATED', mapNumber: index + 1 }
  })
}

// 在显示平面分开相近图钉；包括服务端为同一网格生成的略有偏移的坐标。
export function incidentMarkerOffsets (items, project = (x, y) => [x, y]) {
  const placed = []
  return items.map(item => {
    const base = project(Number(item.x), Number(item.y))
    const clear = p => placed.every(q => Math.hypot(base[0] + p[0] - q[0], base[1] + p[1] - q[1]) >= 24)
    let offset = [0, 0]
    if (!clear(offset)) search: for (let ring = 1; ring <= items.length; ring++) for (let n = 0; n < 8 * ring; n++) {
      const angle = n / (8 * ring) * Math.PI * 2, candidate = [Math.round(Math.cos(angle) * ring * 26), Math.round(Math.sin(angle) * ring * 26)]
      if (clear(candidate)) { offset = candidate; break search }
    }
    placed.push([base[0] + offset[0], base[1] + offset[1]])
    return offset
  })
}
export function incidentMarkerOffset (items, index) { return incidentMarkerOffsets(items)[index] }
